import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  containerFooter: {
    backgroundColor: "#eeeeee",
    position: "relative",
    zIndex: 1
  },
  containerFooterBack: {
    backgroundColor: "#0073cf",
    position: "relative",
    padding: 0,
    zIndex: 1,
    minHeight: 73,
    [theme.breakpoints.down("lg")]: {
      minHeight: 65
    },

    [theme.breakpoints.up("sm")]: {
      display: "grid",
      alignItems: "center"
    }
  },
  sectionContainer: {
    width: "90%",
    maxWidth: "1280px",
    padding: "0",
    margin: "auto",
    backgroundColor: "#eeeeee",
    [theme.breakpoints.up("sm")]: {
      // padding: "0px 150px"
    }
  },
  sectionContainerBack: {
    alignItems: "center",
    paddingBottom: "0px",
    backgroundColor: "#0073cf",
    padding: 0,
    width: "90%",
    maxWidth: "1280px",
    margin: "auto",
    [theme.breakpoints.up("sm")]: {
      // padding: "0px 150px"
    }
  },
  rowFooter: {
    width: "80%",
    maxWidth: "1080px",
    margin: "auto",
    position: "relative"
  },
  imageContainer: {
    margin: "25.2px 0px",
    width: "160px",
    display: "block",
    [theme.breakpoints.down("lg")]: {
      marginBottom: "20px"
    }
  },
  logoStyles: {
    [theme.breakpoints.down("xs")]: {
      // width: 120,
      // height: 30
    }
  },
  titleFooter: {
    fontSize: "14px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.28px",
    color: "#00338d",
    fontFamily: "Trebuchet",
    marginBottom: "0",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1em"
    }
  },
  subtitleFooter: {
    fontSize: "12.02px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.73",
    letterSpacing: "normal",
    color: "#333333",
    fontFamily: "Trebuchet",
    marginBottom: "10px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.938em"
    }
  },
  helpTitle: {
    fontFamily: "Trebuchet",
    fontSize: "25px",
    lineHeight: "28px",
    minHeight: "16px",
    paddingLeft: "0px",
    marginBottom: "30px",
    color: "#666666",
    [theme.breakpoints.down("lg")]: {
      marginBottom: "20px"
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "28px",
      lineHeight: "32px",
      letterSpacing: "-0.44px"
    }
  },
  fontWeightNormal: {
    fontWeight: "normal"
  },
  mb3: {
    marginBottom: 10
  },
  textBold: {
    fontWeight: "bold"
  },
  listFooter: {
    textAlign: "left",
    listStyle: "none",
    listStyleType: "none !important",
    padding: "0 !important",
    marginTop: "5px"
  },
  subtitleListFooter: {
    fontSize: "12.52px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.73",
    letterSpacing: "normal",
    color: "#333333",
    fontFamily: "Trebuchet",
    marginBottom: "10px",
    textDecoration: "none !important",
    "& a:hover": {
      color: "red"
    }
  },
  dividerStyle: {
    width: "90%",
    maxWidth: "1280px",
    padding: "0",
    margin: "auto",
    background: "#00b9e4",
    marginBottom: "20px",
    [theme.breakpoints.down("lg")]: {
      marginBottom: "10px"
    }
  },
  marginSubtitle: {
    marginBottom: 0
  },
  paddingBottomBack: {
    paddingBottom: 20
  },
  subscribeContainer: {
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      marginTop: 30
    }
  },
  emailSuscribe: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  titleBack: {
    fontFamily: "Trebuchet",
    fontSize: 12,
    color: "#ffffff",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      padding: "20px 0px 10px 0px",
      fontSize: 15
    }
  },
  subtitleBack: {
    fontFamily: "Trebuchet",
    fontSize: 10,
    color: "#66bbff",
    [theme.breakpoints.down("xs")]: {
      padding: "10px 0px 7px 0px",
      fontSize: 12
    }
  },
  displayItemBack: {
    display: "flex",
    justifyContent: "space-evenly"
  },
  displaySocial: {
    textAlign: "center"
  },
  socialNetwork: {
    margin: 5,
    color: "#0073cf",
    backgroundColor: "#ffffff",
    height: 36,
    width: 36,
    transition: "transform 300ms ease 0ms",
    "&:hover": {
      backgroundColor: "#ffffff",
      transform: "scaleX(1.2) scaleY(1.2)!important"
    },
    [theme.breakpoints.down("xs")]: {
      margin: "5px 5px 20px 5px"
    }
  },
  hubspotInput: {
    [theme.breakpoints.down("xs")]: {
      marginTop: 10
    },
    "& #hsForm_d1db11fe-b99c-4259-8594-29564c4b6a38": {
      display: "flex",
      alignItems: "baseline",
      justifyContent: "center"
    },
    "& #hsForm_d1db11fe-b99c-4259-8594-29564c4b6a38 .hs_email": {
      width: "340px",
      margin: 0,
      [theme.breakpoints.down("xs")]: {
        width: "100%"
      }
    },
    "& #hsForm_d1db11fe-b99c-4259-8594-29564c4b6a38 .hs_email .hs-input": {
      width: "100%",
      border: "none",
      backgroundColor: "white",
      borderTopLeftRadius: "8px",
      borderBottomLeftRadius: "8px",
      height: "40px",
      paddingLeft: "20px"
    },
    "& #hsForm_d1db11fe-b99c-4259-8594-29564c4b6a38 .hs_submit .hs-button": {
      height: "40px",
      width: "70px",
      backgroundColor: "#0073cf",
      border: "none",
      borderTopRightRadius: "8px",
      borderBottomRightRadius: "8px",
      color: "white",
      cursor: "pointer"
    }
  },
  linkFooterBlue: {
    textDecoration: "none"
  }
}));

export default styles;
